import PropTypes from 'prop-types';
import LayoutContextProvider from './LayoutContextProvider';
import LocaleContextProvider from './LocaleContextProvide';
import SidebarContextProvider from './SidebarContextProvider';
import ThemeContextProvider from './ThemeContextProvider';
import UiWiseAppContextProvider from './UiWiseAppContextProvider';

const AppContextProvider = ({children}) => {
  return (
    <ThemeContextProvider>
      <LocaleContextProvider>
        <LayoutContextProvider>
          <SidebarContextProvider>
            <UiWiseAppContextProvider>{children}</UiWiseAppContextProvider>
          </SidebarContextProvider>
        </LayoutContextProvider>
      </LocaleContextProvider>
    </ThemeContextProvider>
  );
};

export default AppContextProvider;

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
